(ns iris.logs.route-data
  (:require
   [iris.logs.events :as logs-events]))


(defn- route-params [route]
  (get-in route [:route :route-params]))


(defn- query-params [route]
  (or (get-in route [:route :query-params]) {}))


(defn- logs-query-params [_db route]
  {:query-params (query-params route)})


(defn- scoped-query-params [param-key]
  (fn [_db route]
    (when-let [param (get (route-params route) param-key)]
      {:param        param
       :query-params (query-params route)})))


(defn- query-load-key [{:keys [query-params]}]
  (select-keys query-params [:page :activity]))


(defn- scoped-load-key [{:keys [param query-params]}]
  {:param param
   :query (select-keys query-params [:page :activity])})


(defn- logs-effects [{:keys [query-params]}]
  [[::logs-events/load-logs-dashboard]
   [::logs-events/sync-logs-query query-params]])


(defn- scoped-effects [load-event sync-event]
  (fn [{:keys [param query-params]}]
    [[load-event param]
     [sync-event param query-params]]))


(def panel-loaders
  {:logs-panel
   {:params-fn   logs-query-params
    :load-key-fn query-load-key
    :effects-fn  logs-effects}

   :logs-header-panel
   {:params-fn   (scoped-query-params :header)
    :load-key-fn scoped-load-key
    :effects-fn  (scoped-effects ::logs-events/load-header-dashboard
                                  ::logs-events/sync-header-query)}

   :logs-post-panel
   {:params-fn   (scoped-query-params :id)
    :load-key-fn scoped-load-key
    :effects-fn  (scoped-effects ::logs-events/load-post-dashboard
                                  ::logs-events/sync-post-query)}

   :logs-thread-panel
   {:params-fn   (scoped-query-params :id)
    :load-key-fn scoped-load-key
    :effects-fn  (scoped-effects ::logs-events/load-thread-dashboard
                                  ::logs-events/sync-thread-query)}

   :logs-ip-panel
   {:params-fn   (scoped-query-params :ip)
    :load-key-fn scoped-load-key
    :effects-fn  (scoped-effects ::logs-events/load-ip-dashboard
                                  ::logs-events/sync-ip-query)}

   :logs-eid-panel
   {:params-fn   (scoped-query-params :eid)
    :load-key-fn scoped-load-key
    :effects-fn  (scoped-effects ::logs-events/load-eid-dashboard
                                  ::logs-events/sync-eid-query)}

   :logs-user-panel
   {:params-fn   (scoped-query-params :user)
    :load-key-fn scoped-load-key
    :effects-fn  (scoped-effects ::logs-events/load-user-dashboard
                                  ::logs-events/sync-user-query)}})
